import { app } from '../../../app';

app.component('companyReportsHeader', {
    templateUrl: require('./header.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/header.component.js